import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const downloadClasswiseFS_PDF = ({
    reportData,
    selectedYear1
}) => {

    const formatAmount = (amount) =>
        Number(amount || 0).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

    const doc = new jsPDF("landscape", "mm", "a4");

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const now = new Date();
    const timestamp = now.toLocaleString();

    //----------------------------------------------------
    // Header
    //----------------------------------------------------

    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.setTextColor(0, 102, 204);

    doc.text(
        "St. Haris High School",
        pageWidth / 2,
        15,
        { align: "center" }
    );

    doc.setFontSize(11);
    doc.setTextColor(0);

    doc.text(
        `Classwise Fee Structure (${selectedYear1}-${Number(selectedYear1) + 1})`,
        pageWidth / 2,
        22,
        { align: "center" }
    );

    doc.line(14, 28, pageWidth - 14, 28);

    //----------------------------------------------------
    // Group Standard
    //----------------------------------------------------

    const grouped = reportData.reduce((acc, row) => {

        if (!acc[row.std_name]) {
            acc[row.std_name] = [];
        }

        acc[row.std_name].push(row);

        return acc;

    }, {});

    let currentY = 35;

    Object.keys(grouped).forEach((stdName, index) => {

        const rows = grouped[stdName];

        //----------------------------------------
        // New page if required
        //----------------------------------------

        if (currentY > pageHeight - 50) {
            doc.addPage();
            currentY = 20;
        }

        //----------------------------------------
        // Standard Heading
        //----------------------------------------

        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");

        doc.text(
            `Standard : ${stdName}`,
            14,
            currentY
        );

        currentY += 5;

        //----------------------------------------
        // Table
        //----------------------------------------

        autoTable(doc, {

            startY: currentY,

            head: [[
                "Fee Components",
                "Installment No",
                "Fees Type",
                "Fee Amount",
                "Yearly Fee Amount"
            ]],

            body: rows.map(r => [

                r.fee_desc,
                r.install_no,
                r.fee_type,
                formatAmount(r.fee_amt),
                formatAmount(r.yearly_amt)

            ]),

            theme: "grid",

            styles: {

                fontSize: 8,
                cellPadding: 2

            },

            headStyles: {

                fillColor: [0, 102, 204],
                textColor: 255,
                fontStyle: "bold",
                halign: "center"

            },

            columnStyles: {

                0: {
                    cellWidth: 120,
                    halign: "left"
                },

                1: {
                    cellWidth: 35,
                    halign: "center"
                },

                2: {
                    cellWidth: 30,
                    halign: "center"
                },

                3: {
                    cellWidth: 40,
                    halign: "right"
                },

                4: {
                    cellWidth: 45,
                    halign: "right"
                }

            }

        });

        //----------------------------------------
        // Total
        //----------------------------------------

        const total = rows.reduce(
            (sum, r) => sum + Number(r.yearly_amt || 0),
            0
        );

        currentY = doc.lastAutoTable.finalY + 7;

        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");

        doc.text(
            `Total Yearly Fee Amount (${stdName})`,
            150,
            currentY
        );

        doc.text(
            formatAmount(total),
            pageWidth - 20,
            currentY,
            {
                align: "right"
            }
        );

        currentY += 10;

    });

    //----------------------------------------------------
    // Footer on every page
    //----------------------------------------------------

    const pages = doc.getNumberOfPages();

    for (let i = 1; i <= pages; i++) {

        doc.setPage(i);
        doc.setFontSize(8);

        doc.line(
            14,
            pageHeight - 14,
            pageWidth - 14,
            pageHeight - 14
        );

        doc.text(
            "eSchool",
            14,
            pageHeight - 8
        );

        doc.text(
            `Generated : ${timestamp}`,
            pageWidth / 2,
            pageHeight - 8,
            {
                align: "center"
            }
        );

        doc.text(
            `Page ${i} of ${pages}`,
            pageWidth - 14,
            pageHeight - 8,
            {
                align: "right"
            }
        );

    }

    doc.save(`Classwise_Fee_Structure_${selectedYear1}-${Number(selectedYear1) + 1}.pdf`);

};
